import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { Gapped } from '@skbkontur/react-ui';
import { validateComboBox } from '../../helpers/validators';
import { FieldWrapper } from '../FieldWrapper';
import { TrimmedInput } from '../TrimmedInput';
import { BanksCombo } from './components/BanksCombo';
import { ModeSwitch } from './components/ModeSwitch';
export const BanksDirectory = ({ required, banksList = [], bik, bikValidationInfo, onBikChange, name, nameValidationInfo, onNameChange, labels, onModeSwitch, banksComboValidationInfo, dataTids, }) => {
    const [mode, setMode] = useState('manual');
    useEffect(() => {
        const candidate = banksList.find(({ code, name: nameFromList }) => code === bik && nameFromList === name);
        if (!candidate && bik && name) {
            return;
        }
        if (candidate || banksList.length > 0) {
            setMode('auto');
        }
    }, []);
    const item = useMemo(() => {
        return { code: bik, name };
    }, [bik, name]);
    const handleBanksDirectoryChange = (value) => {
        onBikChange(value.code);
        onNameChange(value.name);
    };
    const handleModeChange = (value) => {
        onModeSwitch && onModeSwitch(value);
        setMode(value);
        if (value === 'manual') {
            return;
        }
        const candidate = banksList.find(({ code }) => code === bik);
        if (candidate) {
            handleBanksDirectoryChange(candidate);
            return;
        }
        bik && handleBanksDirectoryChange({ code: bik, name: '' });
    };
    return (_jsxs(Gapped, { vertical: true, gap: 8, children: [mode === 'auto' && (_jsx(BanksCombo, { banksList: banksList, onValueChange: handleBanksDirectoryChange, validationInfo: validateComboBox({
                    value: item,
                    required,
                    items: banksList,
                }) || banksComboValidationInfo, value: item, label: labels?.banksCombo || 'Банк' })), mode === 'manual' && (_jsxs(Gapped, { "data-tid": dataTids?.manualMode, gap: 16, vertical: true, children: [_jsx(FieldWrapper, { label: labels?.bikInput || 'БИК', children: _jsx(TrimmedInput, { width: 224, value: bik, mask: "999999999", onValueChange: onBikChange, validationInfo: bikValidationInfo, "data-tid": dataTids?.bikInput }) }), _jsx(FieldWrapper, { label: labels?.nameInput || 'Наименование', children: _jsx(TrimmedInput, { width: 312, value: name, onValueChange: onNameChange, validationInfo: nameValidationInfo, "data-tid": dataTids?.orgNameInput }) })] })), banksList.length > 0 && (_jsx(FieldWrapper, { label: null, children: _jsx(ModeSwitch, { mode: mode, onModeCnage: handleModeChange, labelAuto: labels?.modeSwitchManual || 'Выбрать банк из списка', labelManual: labels?.modeSwitchAuto || 'Заполнить реквизиты вручную' }) }))] }));
};
